import React from 'react';
import { Link } from 'react-router-dom';
import { FaShoppingCart, FaHeart } from 'react-icons/fa';

function PostCard({ post, onFavorite, isFavorite }) {
  return (
    <article className="post-card">
      <img src={post.image} alt={post.title} className="post-image" />
      <div className="post-content">
        <h2 className="post-title">{post.title}</h2>
        <div className="post-meta">
          <span className="post-date">
            <FaShoppingCart /> {post.date}
          </span>
          <span className="post-author">{post.author}</span>
        </div>
        <p className="post-excerpt">{post.excerpt}</p>
        <div className="post-actions">
          <Link to={`/post/${post.id}`} className="btn btn-primary">
            Leggi di Piu
          </Link>
          <button 
            className={`btn btn-favorite ${isFavorite ? 'active' : ''}`}
            onClick={() => onFavorite(post.id)}
          >
            <FaHeart /> {isFavorite ? 'Salvato' : 'Salva'}
          </button>
        </div>
      </div>
    </article>
  );
}

export default PostCard;